import * as React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { AppRoute } from "../../AppRoute";
import { Link } from "react-router-dom"

export function Footer() {
  const { t } = useTranslation()
  const currentYear = new Date().getFullYear()

  return (
    <footer>
      <Container>
        <Row className="p-3">
          <Col sm={12} md={6} className="p-0 text-nowrap">
            &copy; {currentYear} Clinical Reference Laboratory, Inc.
          </Col>
          <Col sm={12} md={6} className="p-0 d-flex flex-wrap justify-content-center justify-content-md-end">
            <Link className="mx-2 text-nowrap" to={AppRoute.ClientOrder}>{t("footer.clientOrder")}</Link>
            <Link className="mx-2 text-nowrap" to={AppRoute.RegistrationAlt}>{t("footer.registration")}</Link>
            <Link className="mx-2 text-nowrap" to={AppRoute.Results}>{t("footer.results")}</Link>
            <a className="mx-2 text-nowrap" href={AppRoute.FAQ} target="_blank" rel="noopener noreferrer">FAQ</a>
            <a className="mx-2 text-nowrap" href="https://www.crlcorp.com/notice-of-privacy-practices/" target="_blank" rel="noopener noreferrer">{t("footer.privacyPolicy")}</a>
            <a className="mx-2 text-nowrap" href="https://www.crlcorp.com/terms-of-use/" target="_blank" rel="noopener noreferrer">{t("footer.termsOfUse")}</a>
          </Col>
        </Row>
      </Container>
    </footer>
  )
}
